import { Component, OnInit } from "@angular/core";
import { CareerService } from "./career.service";
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.css"],
})
export class CareersComponent implements OnInit {
  errorObj: any = {};
  formObj: any = {
    job_title: {
      es: "",
      en: "",
    },
    job_type: {
      es: "",
      en: "",
    },
    location: {
      es: "",
      en: "",
    },
    exp_from: {
      es: "",
      en: "",
    },
    exp_to: {
      es: "",
      en: "",
    },
    description: {
      es: "",
      en: "",
    },
  };
  defaultFormObj: any = {
    job_title: {
      es: "",
      en: "",
    },
    job_type: {
      es: "",
      en: "",
    },
    location: {
      es: "",
      en: "",
    },
    exp_from: {
      es: "",
      en: "",
    },
    exp_to: {
      es: "",
      en: "",
    },
    description: {
      es: "",
      en: "",
    },
  };
  career: boolean = false;
  jobList: any = [];

  constructor(
    private careerService: CareerService,
    private notif: NotificationsService,
    private userService: UserService
  ) {
    this.loadTableData();
  }

  loadTableData() {
    this.careerService.geAllCareers().subscribe((response) => {
      this.jobList = response.data;
    });
  }

  clearError(field) {
    switch (field) {
      case "name":
        this.errorObj.name = "";
        break;
    }
  }

  resetForm() {
    this.formObj = this.defaultFormObj;
    if (this.formObj._id) delete this.formObj._id;
    this.loadTableData();
  }

  careerForm(obj: any, editableObj = null) {
    if (obj == "show") {
      this.career = true;
    } else if (obj == "hide") {
      this.career = false;
    }
    if (editableObj) {
      this.formObj = editableObj;
    }
  }
  addCareers(career) {
    if (this.formObj.job_title.en === '') {
      this.errorObj.job_title_en = "Job title en is required";
      this.notif.error('Error',this.errorObj.job_title_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
     return false;
    }else if (this.formObj.job_type.en === '') {
      this.errorObj.job_type_en = "Job type en is required";
      this.notif.error('Error',this.errorObj.job_type_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }else if (this.formObj.location.en === '') {
      this.errorObj.location_en = "location en is required";
      this.notif.error('Error',this.errorObj.location_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.exp_from.en === '') {
      this.errorObj.exp_from_en = "Exp from en is required";
      this.notif.error('Error',this.errorObj.exp_from_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.exp_to.en === '') {
      this.errorObj.exp_to_en = "Exp to en is required";
      this.notif.error('Error',this.errorObj.exp_to_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.description.en === '') {
      this.errorObj.description_en = "Description en is required";
      this.notif.error('Error',this.errorObj.description_en, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    if (this.formObj.job_title.es === '') {
      this.errorObj.job_title_es = "Job title es is required";
      this.notif.error('Error',this.errorObj.job_title_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
     return false;
    }else if (this.formObj.job_type.es === '') {
      this.errorObj.job_type_es = "Job type es is required";
      this.notif.error('Error',this.errorObj.job_type_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }else if (this.formObj.location.es === '') {
      this.errorObj.location_es = "location es is required";
      this.notif.error('Error',this.errorObj.location_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.exp_from.es === '' ) {
      this.errorObj.exp_from_es = "Exp from es is required";
      this.notif.error('Error',this.errorObj.exp_from_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.exp_to.es === '' ) {
      this.errorObj.exp_to_es = "Exp to es is required";
      this.notif.error('Error',this.errorObj.exp_to_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    else if (this.formObj.description.es === '') {
      this.errorObj.description_en = "Description es is required";
      this.notif.error('Error',this.errorObj.description_es, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
      })
      return false;
    }
    
    this.userService.csrf().subscribe((success) => {
      this.formObj["_csrf"] = success._csrf;
      this.formObj["is_active"] = true;
      this.careerService.saveCareers(this.formObj).subscribe(
        (response) => {
          this.notif.success("Success", response.data.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
          career.resetForm({});
          this.resetForm();
        },
        (err) => {
          this.notif.error("Error", err.message, {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
      );
    });
  }
  deleteCareer(job) {
    this.userService.csrf().subscribe((success) => {
      job["_csrf"] = success._csrf;
      this.careerService.deleteCareer(job).subscribe((response: any) => {
        this.notif.success("Deleted successfully", response.data.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.resetForm();
      });
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/careers/careers.component.ts